import React, { useEffect, useRef, useState } from 'react';
import ProjectDetails from './ProjectDetails';
import data from './Data'
import { Zoom } from 'react-reveal';

const Projects = () => {
  const [project, setProject] = useState([])
  const [activeall, setActiveall] = useState(false);
  const [activedesign, setActivedesign] = useState(false);
  const [activedev, setActivedev] = useState(false);

  const ref = useRef(null);



  useEffect(() => {
    ref.current.click();
  }, [])
 
  const handleProject = (types) => {
    if(types === "all"){
      setProject(data);
      setActiveall(true)
         setActivedesign(false);
         setActivedev(false);
    }
    else if(types === "design"){
        const result = data.filter((data) => data.type === "design");
        setProject(result);
        setActivedesign(true)
          setActivedev(false);
            setActiveall(false);

    }
    else{
        const result = data.filter((data) => data.type === "development");
        setProject(result);
        setActivedev(true);
         setActivedesign(false);
            setActiveall(false);

    }

};
  console.log(project);
  return (
    <Zoom >
    <div id='projects' className="py-10 w-full bg-[#1f1f38] ">
      <h2 className="text-4xl font-bold text-center text-white mb-10">
        MY PROJECTS
      </h2>
      <div className="button flex justify-center ">
        <button ref={ref}
         className={
          activeall
            ? "btn  mx-2"
            : "btn btn-outline  mx-2 text-white mx-2"
        }
          onClick={() => handleProject("all")}
        >
          ALL
        </button>
        <button
          className={activedesign ? "btn  mx-2" : "btn btn-outline  mx-2 text-white mx-2"}
          onClick={() => handleProject("design")}
        >
          Web Design
        </button>
        <button
         className={activedev ? "btn  mx-2" : "btn btn-outline  mx-2 text-white mx-2"}
          onClick={() => handleProject("development")}
        >
          MERN Projects
        </button>
      </div>
      <div className="flex justify-evenly items-start flex-wrap">
        {project.map((data) => (
          <ProjectDetails data={data} 
         />
        ))}
      </div>

     
    </div>
    </Zoom>
  );
};

export default Projects;